<template>
  <pict
    class="platinum-image__image"
    block-name="platinum-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageLEN from "./images/desktop-en.png"
import imageL2xEN from "./images/desktop-en@2x.png"
import imageLDE from "./images/desktop-de.png"
import imageL2xDE from "./images/desktop-de@2x.png"
import imageLES from "./images/desktop-es.png"
import imageL2xES from "./images/desktop-es@2x.png"

export default {
  name: "PurchaseImage",
  components: {
    Pict
  },
  data: () => ({
    images: {
      en: {
        l: imageLEN,
        l2x: imageL2xEN
      },
      de: {
        l: imageLDE,
        l2x: imageL2xDE
      },
      es: {
        l: imageLES,
        l2x: imageL2xES
      }
    }
  }),
  computed: {
    imageProps() {
      return {
        default: {
          src: this.images[this.$i18n.locale].l,
          srcset: {
            "2x": this.images[this.$i18n.locale].l2x
          }
        },
        sources: []
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A screenshot of Blinkist platinum's features"
      },
      de: {
        alt: "Ein Screenshot von Blinkist Platinum's Features"
      },
      es: {
        alt: "Una captura de pantalla de Blinkist Platinum's Features"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.platinum-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
